export const budgetPDFLink =
  "https://cassette.sphdigital.com.sg/attachments/beritaharian/feef703f82063b93f89f508bf19c3d2f6f3304ded762ac72a359cb82139bdd41";

export const ENABLE_BUDGET_PDF_BANNER =
  import.meta.env.VITE_BUDGET_PDF_2026 === "1";
